const UsageTableTitle = [
    {
        prop: "idx",
        label: "序号",
        width: "80",
    },
    {
        prop: "rootName",
        label: "层级名称",
        width: "200",
    },
    {
        prop: "meterName",
        label: "设备名称",
        width: "200",
    },
    {
        prop: "useKwh",
        label: "用电量kwh",
        width: "200",
    },
]
export { UsageTableTitle }